// 判断是整数
// 在某种特殊情况下lodash的isNaN被写入全局下 需要此种方法来处理
var _isNaN = function (val) {
  return isNaN(Number(val))
}
const removeBlank = function (el, val) {
  var newValue = val.replace(/\s/g, '')
  if (val !== newValue) {
    el.value = newValue
  }
}
const isInteger = function (element) {
  var el = this.$el.querySelector(element)
  var val = el.value
  // 适配ie
  if (val === '') {
    return val
  }
  if (val !== '-' && (_isNaN(val) || /\./g.test(val))) {
    val = val.replace(/[^\d]/g, '').replace(/-{2,}/g, '-')
    el.value = val
  } else {
    removeBlank.call(this, el, val)
  }
  return val
}
// 判断是正整数
const isPositiveInteger = function (element) {
  var el = this.$el.querySelector(element)
  var val = el.value
  // 适配ie
  if (val === '') {
    return val
  }
  if (_isNaN(val) || /(\.|-)/g.test(val)) {
    val = val.replace(/[^\d]/g, '').replace(/-/g, '')
    el.value = val
  }
  if (this.inCludeZero && val === 0) {
    removeBlank.call(this, el, val)
  } else {
    if (val <= 0) {
      el.value = ''
    } else {
      removeBlank.call(this, el, val)
    }
  }
  return val
}
// 判断是正数
const isPositivenumber = function (element) {
  var el = this.$el.querySelector(element)
  var val = el.value
  // 适配ie
  if (val === '') {
    return val
  }
  if (_isNaN(val)) {
    val = val.replace(/[^\d]/g, '').replace(/-{2,}/g, '-')
    el.value = val
  }
  if (val <= 0) {
    el.value = val.replace(/-/g, '')
  } else {
    removeBlank.call(this, el, val)
  }
  return val
}
export {
  isInteger,
  isPositiveInteger,
  isPositivenumber
}



// WEBPACK FOOTER //
// ./src/util/formatFunc.js